module.exports = __webpack_public_path__ + "img/00634453001818.d25fe53d.png";